<template>
	<div class="phone-login">
		<el-form :model="codeForm" :rules="codeRules" ref="codeForm" class="login-from">
			<el-form-item prop="phone">
				<el-input v-model="codeForm.phone" placeholder="请输入手机号" :maxlength="11"></el-input>
			</el-form-item>
			<el-form-item prop="code" class="code-item">
				<el-input v-model="codeForm.code" placeholder="请输入验证码" @change="codeChange" :maxlength="6"
					autocomplete="new-password"></el-input>

				<div :class="[codeBtnVal == '获取验证码' ? 'get-code' : 'get-code2']" @click="clickCode">
					{{ codeBtnVal }}
				</div>
			</el-form-item>
		</el-form>
		<privacyPolicy :selectFlag="selectFlag" :subshow="subshow" @checkSelect="checkSelect" />

		<div class="login-btn">
			<button @click="codeLogin" @keyup.enter="(e) => keyDown(e)">{{ loginName }}</button>
		</div>
	</div>
</template>

<script>
import { phoneLogin, getDynamicCode } from "@/../api";
import { zhugeTrack, jumpAfterLogin } from "@/utils/utils";
import privacyPolicy from "../common/privacy-policy.vue";
import { mapState, mapMutations } from "vuex";
export default {
	name: "",
	props: ["referUrl"],
	data() {
		return {
			loginName: "登录",
			selectFlag: false, //是否勾选协议
			subshow: false,
			codeForm: {
				phone: "",
				code: "",
			},
			codeRules: {
				phone: [
					{ required: true, message: "请输入手机号", trigger: "blur" },
					{
						pattern: /^1\d{10}$/,
						message: "手机号格式不正确!",
						trigger: "blur",
					},
				],
				code: [
					{ validator: this.codeValidator },
					{ required: true, message: "请输入动态验证码", trigger: "blur" },
					{ min: 6, max: 6, message: "验证码不正确", trigger: "blur" },
				],
			},
			codeerrorMessage: "请输入正确验证码，连续输入错误，账号将被锁定",
			codeErr: false,
			codeBtnVal: "获取验证码",

		};
	},
	mounted() {
		window.addEventListener('keydown', this.keyDown)
	},
	destroyed() {
		window.removeEventListener('keydown', this.keyDown, false)
	},
	components: {
		privacyPolicy
	},

	computed: {
		...mapState(["isToastshow", "message", "manyloginToast", "isProtocolLogin", "protocolDialogVisible", "sliderResult"]),
	},
	watch: {
		"sliderResult": {
			handler(val) {
				if (val) {
					this.getCode(val)
				}
			},
			deep: true,
			immediate: true
		},
		"isProtocolLogin": {//同意协议，直接登录
			handler(val) {
				if (val) {
					this.codeLoginYes()
				}
			},
			deep: true,
			immediate: true
		}
	},
	methods: {
		...mapMutations(
			[
				"toastshow", "toastHidden", "manyLoginToastshow",
				"protocolDialogshow", "protocolDialogHidden", "isProtocolLoginYes",
				"isProtocolLoginNo", "isShowSliderVerifyHandle", "sliderResultHandle"
			]
		),
		keyDown(e) {
			if ((e.keyCode == 13 || e.keyCode == 100) && !this.protocolDialogVisible) {//无弹框才enter键才有效

				this.codeLogin(e)
			}
		},
		checkSelect() {
			this.selectFlag = !this.selectFlag;
			if (this.selectFlag) {
				this.subshow = false;
			}
		},
		// 动态验证码校验
		codeValidator(rule, value, callback) {
			if (this.codeErr) {
				return callback(new Error(this.codeerrorMessage));
			} else {
				callback();
			}
		},
		show(message = "默认", duration = 3000) {
			this.toastshow(message);

			const toastTimer = setTimeout(() => {
				this.toastHidden();
				clearTimeout(toastTimer);
			}, duration);
		},
		//点击验证码
		clickCode() {
			if (this.codeBtnVal != "获取验证码") return;
			if (
				!this.codeForm.phone ||
				this.codeForm.phone.length < 11 ||
				this.codeForm.phone[0] != 1
			) {
				this.$refs["codeForm"].validateField("phone");
				return;
			}
			this.$refs["codeForm"].clearValidate("code")
			localStorage.setItem('currUserPhone', this.codeForm.phone)
			this.isShowSliderVerifyHandle(true)
		},
		// 获取验证码
		getCode(validCode) {
			let _this = this;
			let params = {
				mobileOrEmail: this.codeForm.phone.trim(),
				vType: 6,
				messageType: 1,
				validCode: validCode
			};
			this.codeBtnVal = "发送中...";
			this.sliderResultHandle(false)//清空拼图操作结果
			getDynamicCode(params)
				.then((res) => {
					let data = res.data;
					if (data.success) {
						// 获取验证码成功
						let num = 60;
						var timer = setInterval(() => {
							if (num <= 0) {
								_this.codeBtnVal = "获取验证码";
								clearInterval(timer);
							} else {
								_this.codeBtnVal = num-- + "s";
							}
						}, 1000);
					} else {
						this.codeerrorMessage = data.developerMsg;
						this.codeErr = true;
						this.$refs["codeForm"].validateField("code");
						this.codeBtnVal = "获取验证码";
					}
				})
				.catch((err) => {
					this.show(err);
					this.codeBtnVal = "获取验证码";
				});
		},
		codeLoginYes() {
			let did = zhuge.getDid();
			let sid = zhuge.getSid();
			let params = {
				userName: this.codeForm.phone,
				code: this.codeForm.code,
				additional: did + "@" + sid,
				rememberMe: true,
			};
			this.isProtocolLoginNo()
			this.loginName = "登录中...";
			phoneLogin(params).then((res) => {
				let data = res.data;
				if (data.code == 200) {
					this.codeErr = false;
					localStorage.removeItem(this.codeForm.phone);
					if(data.data.needChangePassword && this.referUrl && this.referUrl.indexOf('match')>-1){//传智杯第一次登陆
						this.$router.push({
							name: "edit-pass",
							query: {
							refer: this.referUrl ? this.referUrl : undefined
							},
						});
					}else{
						// 登录成功后的跳转
						jumpAfterLogin(this.referUrl);
					}
					data.freshOrNot ? zhugeTrack("注册成功", {
						终端: "Web",
						登录方式: "短信验证码",
					}) :
						zhugeTrack("登录成功", {
							终端: "Web",
							登录方式: "短信验证码",
						});
					this.loginName = "登录";
				} else if (data.code == 401) {
					this.codeErr = true;
					this.codeerrorMessage =
						"请输入正确验证码，连续输入错误，账号将被锁定";
					this.$refs["codeForm"].validateField("code");

				} else if (data.code == 423) {
					this.manyLoginToastshow();
				} else {
					this.show("登录失败");
				}

				this.loginName = "登录";
			});
		},
		// 验证码登录
		codeLogin() {
			if (this.loginName != "登录") return;


			this.$refs["codeForm"].validate((valid) => {
				if (valid) {
					if (!this.selectFlag && !this.isProtocolLogin) {
						this.subshow = true;

						this.protocolDialogshow()
						return;
					}
					this.codeLoginYes()
				}
			});
			zhugeTrack("点击_登录", {
				'终端': 'Web',
				'登陆方式': '短信验证码'
			});
		},
		// 校验验证码更改时，移除错误校验提示
		codeChange() {
			this.codeErr = false;
		},
	},
};
</script>

<style lang="scss" scoped>
.phone-login {
	position: relative;

	p {
		width: 100%;
	}

	h1 {
		height: 40px;
		font-family: PingFangSC-Regular;
		font-size: 40px;
		color: #2c2c40;
		letter-spacing: 0;
		line-height: 40px;
		font-weight: 400;
	}

	.code-item {
		position: relative;

		::v-deep .el-form-item__content {
			display: flex;
		}

		::v-deep .el-input {
			display: flex;
			width: 240px;

			.el-input__inner {
				width: 240px;
				height: 40px;
				line-height: 40px;
				border-radius: 4px;
				border: 1px solid #e5e6eb;
			}
		}

		.get-code {
			width: 112px;
			height: 40px;
			background: #e8f3ff;
			border-radius: 4px;
			font-size: 14px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #4e5969;
			line-height: 40px;
			text-align: center;
			margin-left: 16px;
			cursor: pointer;

			&:hover {
				color: #165dff;
			}
		}

		.get-code2 {
			width: 112px;
			height: 40px;
			background: #e8f3ff;
			border-radius: 4px;
			font-size: 14px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #4e5969;
			line-height: 40px;
			text-align: center;
			margin-left: 16px;
		}
	}

	.privacyPolicy {
		margin-top: 32px;
	}

	.login-btn {
		margin-top: 16px;
	}
}
</style>
